// NPM
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

class ResultsActionButton extends Component {
  render() {
    const { className, onClick, children, href } = this.props;
    return (
      <Button
        className={`ResultsActionButton ${className}-results`}
        bsStyle={'default'}
        onClick={onClick}
        href={href}
      >
        {children}
      </Button>
    );
  }
}

ResultsActionButton.propTypes = {
  className: PropTypes.string.isRequired,
};

export default ResultsActionButton;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultsActionButton.js